import { UserBuilder, PublicationStatus } from '../../common';
import { RandomGenerator } from '../../../test-utils';
var ArticleVersionBuilder = /** @class */ (function () {
    function ArticleVersionBuilder() {
        this.articleVersion = {
            content: {
                content: '',
                title: ''
            },
            createdByUser: new UserBuilder().build(),
            creationDate: new Date().getTime(),
            id: RandomGenerator.id(),
            lastUpdateDate: new Date().getTime(),
            publicationStatus: PublicationStatus.DRAFT
        };
    }
    ArticleVersionBuilder.prototype.withContent = function (content) {
        this.articleVersion.content = content;
        return this;
    };
    ArticleVersionBuilder.prototype.withCreatedByUser = function (createdByUser) {
        this.articleVersion.createdByUser = createdByUser;
        return this;
    };
    ArticleVersionBuilder.prototype.withCreationDate = function (creationDate) {
        this.articleVersion.creationDate = creationDate;
        return this;
    };
    ArticleVersionBuilder.prototype.withId = function (id) {
        this.articleVersion.id = id;
        return this;
    };
    ArticleVersionBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.articleVersion.lastUpdateDate = lastUpdateDate;
        return this;
    };
    ArticleVersionBuilder.prototype.withPublicationStatus = function (publicationStatus) {
        this.articleVersion.publicationStatus = publicationStatus;
        return this;
    };
    ArticleVersionBuilder.prototype.build = function () {
        return this.articleVersion;
    };
    return ArticleVersionBuilder;
}());
export { ArticleVersionBuilder };
//# sourceMappingURL=article-version.builder.js.map